export default "__VITE_ASSET__8dc82ad7__"